<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <el-button type='success' icon='sys sys-search' class='navbarbtn'
        @click='showSPResultSearchDialogMD'>
        盘点结果统计
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.qrCode' style='width: 125px;' placeholder='标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.outerQRCode' style='width: 125px;' placeholder='外箱标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :expandRowKeys='mainTable.expandRowKeys'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='90px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='撤销删除' placement='top-start' v-if='showDeletePower'>
          <el-button type='danger' circle style='padding: 4px;'
            @click='deleteSPCheck(scope)'><i class='sys sys-delete'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 180px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>生产/采购日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>盘点结果</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>物料代码</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>物料名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>物料规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='(qrCode, qrCodeIndex) in scope.data.row.detailDt1'
            :key='qrCode.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'>{{qrCodeIndex + 1}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'>{{qrCode.QRCode}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{qrCode.Qty}}{{qrCode.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 180px; text-align: left;'><span style='color: #42426F;'>{{qrCode.OuterQRCode}} </span></div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'>{{qrCode.SupplyBatchNo}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BatchNo}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.KFDate}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.KFPeriod}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.CKFlag}} </span></div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Number}} </span></div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Name}} </span></div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Model}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog v-dialogDrag title='盘点结果统计条件' :visible.sync='showSPResultSearchDialog' top='10px' width='320px'>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          开始日期
        </div>
        <el-date-picker v-model='startDate' format='yyyy-MM-dd' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
        </el-date-picker>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          结束日期
        </div>
        <el-date-picker v-model='endDate' format='yyyy-MM-dd' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
        </el-date-picker>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          仓库
        </div>
        <el-select v-model='stockID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='stock in stocks'
            :key='stock.StockID' :label='stock.Name' :value='stock.StockID'>
          </el-option>
        </el-select>
      </div>
      <div style='margin-top: 120px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          仓位
        </div>
        <el-input v-model='spNumber' placeholder='左包含'
          class='inputField-input'
          style='width: 200px;' size='mini'>
        </el-input>
      </div>
      <div style='margin-top: 160px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          物料
        </div>
        <el-input v-model='itemNumber' placeholder='左包含'
          class='inputField-input'
          style='width: 200px;' size='mini'>
        </el-input>
      </div>
      <div class='dialogButtomCenterBtn' style='margin-top: 200px;'>
        <el-button type='primary' @click='showSPResultDialogMD()' size='mini'>统计</el-button>
        <el-button @click='showSPResultSearchDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='盘点结果统计条件' :visible.sync='showSPResultDialog' top='10px' width='885px'>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          盘点结果
        </div>
        <el-select v-model='spStrResult' placeholder='请选择盘点结果'
          class='inputField-input' @change='spResultFilter()'
          style='width: 200px;' size='mini'>
          <el-option v-for='strResult in spStrResults'
            :key='strResult.code' :label='strResult.name' :value='strResult.code'>
          </el-option>
        </el-select>
        <el-button type='primary' icon='sys sys-export' style='height: 26px; padding: 0 10px;'
          @click='spResultExport'>
          导 出
        </el-button>
        <el-button type='primary' icon='sys sys-expand'
          style='height: 26px; padding: 0 10px; margin-right: 10px;'
          @click='spResultTableExpandRow'>
          展 开
        </el-button>
        <el-button type='primary' icon='sys sys-narrow'
          style='height: 26px; padding: 0 10px; margin-right: 10px;'
          @click='spResultTableNarrowRow'>
          收 起
        </el-button>
      </div>
      <el-table :data='showSPResults' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        :row-style='spResultRowStyle' row-key='GUID'
        :expand-row-keys='spResultExpandRowKeys'
        style='margin-top: 10px;' :default-expand-all='false'>
        <el-table-column type='expand' width='50'>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>物料代码</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>物料名称</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>物料规格</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 180px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>生产/采购日期</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>盘点结果</span></div>
              </div>
            </div>
            <div class='expand'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.Results'
                :key='qrCode.EntryID' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'>{{qrCodeIndex + 1}} </span></div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'>{{qrCode.QRCode}} </span></div>
                <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Number}} </span></div>
                <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Name}} </span></div>
                <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Model}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{qrCode.Qty}}{{qrCode.UnitName}} </span></div>
                <div class='expand-row' style='min-width: 180px; text-align: left;'><span style='color: #42426F;'>{{qrCode.OuterQRCode}} </span></div>
                <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'>{{qrCode.SupplyBatchNo}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BatchNo}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.KFDate}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.KFPeriod}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.CKFlag}} </span></div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='rowIndex' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='StockNumber' label='仓库' width='100'>
        </el-table-column>
        <el-table-column prop='StockName' label='仓库名称' width='200'>
        </el-table-column>
        <el-table-column prop='SPNumber' label='仓位' width='100'>
        </el-table-column>
        <el-table-column prop='SumQty' label='条码合计' width='100'>
        </el-table-column>
        <el-table-column prop='SPQty' label='盘点合计' width='100'>
        </el-table-column>
        <el-table-column prop='Result' label='盘点结果' width='1000'>
        </el-table-column>
        <el-table-column label='' width='1000'>
        </el-table-column>
      </el-table>
      <div class='pagination tableButtom'>
        <el-pagination
          @size-change='spResultsSizeChange'
          @current-change='spResultsPageChange'
          :current-page='page'
          :page-sizes='[20, 50, 100, 200]'
          :page-size='pageSize'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'>
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'SPCheckRecord',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_SPCheck',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        qrCode: '',
        outerQRCode: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      showSPResultSearchDialog: false,
      stocks: [],
      startDate: '',
      endDate: '',
      stockID: '',
      spNumber: '',
      itemNumber: '',
      showSPResultDialog: false,
      spResults: [],
      filterSPResults: [],
      showSPResults: [],
      total: 0,
      page: 1,
      pageSize: 100,
      spStrResult: '',
      spStrResults: [
        { code: '无库存', name: '无库存' },
        { code: '未盘点', name: '未盘点' },
        { code: '正常', name: '正常' },
        { code: '盘亏', name: '盘亏' }
      ],
      spResultExpandRowKeys: [],

      showDeletePower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const stockObjPromise = table.getTableContent('BD_Stock', 10000, 1, '', " AND TypeId='500' AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const stockObj = await stockObjPromise
    that.stocks = stockObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.qrCode) {
        const qrCodes = that.mainTable.qrCode.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < qrCodes.length; i++) {
          detail1FilterStr += " OR QRCode LIKE '%" + qrCodes[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.outerQRCode) {
        const outerQRCodes = that.mainTable.outerQRCode.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < outerQRCodes.length; i++) {
          detail1FilterStr += " OR OuterQRCode LIKE '%" + outerQRCodes[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      return {}
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 盘点记录撤销删除
    deleteSPCheck: function (scope) {
      const that = this
      that.$confirm('确定要删除该库位盘点记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.DeleteSPCheck', {
          checkNo: scope.data.row.CheckNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 仓位盘点结果查询条件弹出框显示方法
    showSPResultSearchDialogMD: function () {
      const that = this
      that.startDate = dateTimeUtil.addDateTime(new Date(), 'Day', -3, 'yyyy-MM-dd')
      that.endDate = dateTimeUtil.formartDateTime(new Date(), 'yyyy-MM-dd')
      that.stockID = ''
      that.spNumber = ''
      that.showSPResultSearchDialog = true
    },

    // 仓位盘点结果弹出框显示方法
    showSPResultDialogMD: async function () {
      const that = this
      if (!that.startDate) {
        that.$message.error('请选择开始日期！')
        return
      }
      if (!that.endDate) {
        that.$message.error('请选择结束日期！')
        return
      }
      if (!that.stockID) {
        that.$message.error('请选择仓库！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetSPResult', {
        startDate: that.startDate,
        endDate: that.endDate,
        stockID: that.stockID,
        spNumber: that.spNumber,
        itemNumber: that.itemNumber
      })
      if (rtnObj.error === '000000') {
        that.spResults = rtnObj.data
        that.showSPResultSearchDialog = false
        that.showSPResultDialog = true
        that.page = 1
        that.total = that.spResults.length
        that.spResultFilter()
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 盘点结果统计数据过滤方法
    spResultFilter: function () {
      const that = this
      that.filterSPResults = []
      for (let i = 0; i < that.spResults.length; i++) {
        if (!that.spStrResult || that.spResults[i].Result === that.spStrResult) {
          that.filterSPResults.push(that.spResults[i])
        }
      }

      that.showSPResults = []
      for (let i = 0; i < that.filterSPResults.length; i++) {
        that.filterSPResults[i].rowIndex = (i + 1)
        if (that.filterSPResults[i].rowIndex > that.pageSize * (that.page - 1) && that.filterSPResults[i].rowIndex <= that.pageSize * (that.page)) {
          that.showSPResults.push(that.filterSPResults[i])
        }
      }
      that.total = that.filterSPResults.length
      that.page = 1
    },

    spResultsSizeChange: function (val) {
      const that = this
      that.pageSize = val
      that.spResultFilter()
    },

    spResultsPageChange: function (val) {
      const that = this
      that.page = val
      that.spResultFilter()
    },

    spResultRowStyle: function (data, rowIndex) {
      if (data.row.Result === '正常') {
        return { 'background-color': '#A0EEA0' }
      } else if (data.row.Result === '无库存') {
        return { 'background-color': '#CCCCCC' }
      } else if (data.row.Result === '未盘点') {
        return { 'background-color': '#FFAAAA' }
      } else {
        return { 'background-color': '#FFAAAA' }
      }
    },

    spResultExport: function () {
      const that = this
      const exportData = [['行号', '仓库', '仓库名称', '仓位', '条码合计', '盘点合计', '盘点结果', '物料代码', '物料名称', '规格型号', '条码数量', '盘点数量']]
      for (let i = 0; i < that.filterSPResults.length; i++) {
        if (!that.filterSPResults[i].Results || that.filterSPResults[i].Results.length <= 0) {
          exportData.push([
            that.filterSPResults[i].rowIndex,
            that.filterSPResults[i].StockNumber,
            that.filterSPResults[i].StockName,
            that.filterSPResults[i].SPNumber,
            that.filterSPResults[i].SumQty,
            that.filterSPResults[i].SPQty,
            that.filterSPResults[i].Result
          ])
          continue
        }
        let lastItemNumber = ''
        let haveAdd = false
        for (let j = 0; j < that.filterSPResults[i].Results.length; j++) {
          if (that.filterSPResults[i].Results[j].ItemNumber === lastItemNumber) {
            exportData[exportData.length - 1][10] += that.filterSPResults[i].Results[j].Qty
            exportData[exportData.length - 1][11] += that.filterSPResults[i].Results[j].CKFlag === '正常' ? that.filterSPResults[i].Results[j].Qty : 0
          } else {
            lastItemNumber = that.filterSPResults[i].Results[j].ItemNumber
            if (!haveAdd) {
              haveAdd = true
              exportData.push([
                that.filterSPResults[i].rowIndex,
                that.filterSPResults[i].StockNumber,
                that.filterSPResults[i].StockName,
                that.filterSPResults[i].SPNumber,
                that.filterSPResults[i].SumQty,
                that.filterSPResults[i].SPQty,
                that.filterSPResults[i].Result,
                that.filterSPResults[i].Results[j].ItemNumber,
                that.filterSPResults[i].Results[j].ItemName,
                that.filterSPResults[i].Results[j].ItemModel,
                that.filterSPResults[i].Results[j].Qty,
                that.filterSPResults[i].Results[j].CKFlag === '正常' ? that.filterSPResults[i].Results[j].Qty : 0
              ])
            } else {
              exportData.push([
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                that.filterSPResults[i].Results[j].ItemNumber,
                that.filterSPResults[i].Results[j].ItemName,
                that.filterSPResults[i].Results[j].ItemModel,
                that.filterSPResults[i].Results[j].Qty,
                that.filterSPResults[i].Results[j].CKFlag === '正常' ? that.filterSPResults[i].Results[j].Qty : 0
              ])
            }
          }
        }
      }
      const ws = exportExcelHelper.arraySimpleToWSData(exportData)
      const wss = []
      wss.push({ sheetName: 'sheet1', data: ws })
      exportExcelHelper.exportWssToExcel(wss, '盘点结果统计')
    },

    spResultTableExpandRow: function () {
      const that = this
      that.spResultExpandRowKeys = []
      for (let i = 0; i < that.spResults.length; i++) {
        that.spResultExpandRowKeys.push(that.spResults[i].GUID)
      }
    },

    spResultTableNarrowRow: function () {
      const that = this
      that.spResultExpandRowKeys = []
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.tableButtom {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 5px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
</style>
